import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X, Download } from "lucide-react";

export default function FilePreview({ file, signedUrl, onClose }) {
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  if (!file || !signedUrl) return null;

  const isImage = file.mimeType?.startsWith("image/");
  const isPdf = file.mimeType === "application/pdf";

  return createPortal(
    <div
      className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-card text-card-foreground border border-border rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="px-6 py-3 border-b border-border flex items-center justify-between flex-shrink-0">
          <h2 className="text-sm font-medium truncate pr-4">
            {file.displayName || file.fileName}
          </h2>
          <div className="flex items-center gap-2">
            <a
              href={signedUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost h-8 w-8 p-0"
              title="Download"
            >
              <Download className="h-4 w-4" />
            </a>
            <button onClick={onClose} className="btn btn-ghost h-8 w-8 p-0" title="Close">
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto flex items-center justify-center bg-muted/20 min-h-0">
          {isImage && (
            <img
              src={signedUrl}
              alt={file.displayName || file.fileName}
              className="max-w-full max-h-[calc(90vh-4rem)] object-contain"
            />
          )}
          {isPdf && (
            <iframe
              src={signedUrl}
              title={file.displayName || file.fileName}
              className="w-full h-[calc(90vh-4rem)]"
            />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
